<template>
  <el-aside :width="isCollapse ? '64px' : '250px'" v-if="showSidebar">
    <div class="logo" style="background-color: #d61935">
      <a href="#" class="simple-text">
        <div class="logo-img">
          <img src="/static/img/logo.png" alt />
        </div>
        <span v-if="!isCollapse">Vopsa</span>
      </a>
    </div>
    <div class="scroll_menu custom-scroll inverted">
      <el-card
        :style="cssVarsCard"
        :class="'avatar-card' + (isCollapse ? 'small' : '')"
        body-style="padding:0"
        style="background-color: #f8f8f8; margin-top: 0"
      >
        <div
          class="aside-alert-link_wrp"
          style="
            display: flex;
            justify-content: space-between;
            width: 100%;
            align-items: flex-end;
          "
        >
          <el-avatar
            shape="circle"
            :size="55"
            :style="cssVarsCard"
            style="
              display: flex;
              justify-content: center;
              align-content: center;
              align-items: center;
              background-color: transparent;
            "
            ><i class="el-icon-user" style="font-size: 30px; color: #fff"
          /></el-avatar>
          <div class="aside-alert-link">
            <el-tooltip content="Configuracion">
              <i
                style="font-size: 18px"
                class="el-icon-setting"
                click="AdminConfig"
                v-if="isAdmin"
                @click="AdminConfig"
              />
            </el-tooltip>
            <el-tooltip content="Desconectar e ir a la Home">
              <i
                style="font-size: 18px"
                class="el-icon-s-home"
                click="homeDesconectar"
                v-if="
                  isAdmin ||
                  (getProjects !== null &&
                    getProjects !== undefined &&
                    getProjects.length > 0)
                "
                @click="homeDesconectar"
              />
            </el-tooltip>
            <el-tooltip content="Desconectar">
              <i class="fa fa-sign-out" @click="desconectar" style="font-size: 18px"></i>
            </el-tooltip>
          </div>
        </div>

        <h6 class="text mt-3 mb-0">
          {{
            currentUser.email !== undefined
              ? currentUser.email.charAt(0).toUpperCase() + currentUser.email.slice(1)
              : ""
          }}
        </h6>
        <div class="text mt-1" v-if="isAdmin">Administrador</div>
        <div class="text mt-1" v-else>Usuario</div>
      </el-card>
      <el-menu
        :default-active="activeindex"
        class="el-menu-custom custom-sidebar_level"
        :collapse="isCollapse"
        background-color="#f8f8f8"
        text-color="#000"
        active-text-color="#c6c6c6"
      >
        <template v-if="currentUser.rol">
          <el-menu-item
            v-for="plugin in menuPluginsProject"
            :key="plugin.name"
            :index="plugin.name"
            @click="cambio(`/dashboard/${table}/${plugin.path}`)"
            exact
          >
            <i :class="plugin.icon ? plugin.icon : 'el-icon-menu'"></i>
            <span slot="title">{{ plugin.title_sidebar }}</span>
          </el-menu-item>

          <el-menu-item
            v-for="(link, index) in links"
            v-if="link.visible == 1"
            :key="index"
            :index="link.name_table"
            @click="
              cambio(
                '/dashboard/' + table + '/list/' + link.name_table,
                link.display_name_plural
              )
            "
            exact
          >
            <i :class="link.icon ? link.icon : 'el-icon-menu'"></i>
            <span slot="title">{{ link.display_name_plural }}</span>
          </el-menu-item>

          <el-submenu index="ajustes" v-if="isAdmin || userGestorUsuarios == 1">
            <template slot="title">
              <i class="el-icon-setting"></i>
              <span slot="title">Ajustes</span>
            </template>
            <el-menu-item-group>
              <span slot="title">Configuración</span>
              <el-menu-item
                index="ajustes-1"
                @click="cambio('/dashboard/' + table + '/formularios')"
                exact
                v-if="isAdmin"
              >
                <i class="link.icon"></i>
                <span slot="title">Montar formularios</span>
              </el-menu-item>
              <el-menu-item
                index="ajustes-2"
                @click="cambio('/dashboard/' + table + '/usuarios')"
                exact
                v-if="isAdmin || userGestorUsuarios == 1"
              >
                <i class="link.icon"></i>
                <span slot="title">Usuarios</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </template>
      </el-menu>
    </div>
  </el-aside>
</template>
<script>
import ApiService from "@/common/api.service";
import { mapGetters } from "vuex";
import {
  FECTH_SIDEBAR,
  FECTH_NAME_SIDEBAR,
  FECTH_PLUGINS_PROJECT,
  FECTH_USER_ACCESS,
} from "@/store/actions.type";

export default {
  name: "sidebar",

  async created() {
    await localStorage.setItem("table", this.$route.params.db);
    await this.setPluginsProject();
    await this.setAccessUser();

    window.localStorage.getItem("isCollapse") == "true"
      ? (this.isCollapse = true)
      : (this.isCollapse = false);

    if (this.$route.query.hide) {
      this.showSidebar = false;
    }
    this.$root.$on("toogleChange", () => {
      this.toggle();
    });
    await this.findActiveLink();

    this.table = await this.$route.params.db;

    this.getPluginsProject.map((e) => {
      this.userAccessPlugins.map((u) => {
        if (u.name === e.name && u.value.length > 0) this.pluginsProject.push(e);
      });
    });

    await this.getActiveIndex();
  },
  beforeDestroy() {
    this.$root.$off("toogleChange", () => {
      this.toggle();
    });
  },
  data() {
    return {
      links: [],
      table: null,
      isCollapse: false,
      activeindex: null,
      show: false,
      pluginsProject: [],
      showSidebar: true,
    };
  },
  methods: {
    async getActiveIndex() {
      if (this.$route.name == "Dashboard Páginas") {
        this.activeindex = "pages";
        await this.$store.dispatch(FECTH_NAME_SIDEBAR, "Páginas");
      } else if (this.$route.name == "Dashboard-formularios") {
        this.activeindex = "ajustes-1";
        await this.$store.dispatch(FECTH_NAME_SIDEBAR, "Ajustes");
      } else {
        if (this.$route.params.table) {
          let index = this.links.find((link) => {
            return this.$route.params.table == link.name_table;
          });

          if (index !== undefined) {
            this.activeindex = index.name_table;
            await this.$store.dispatch(FECTH_NAME_SIDEBAR, index.display_name_plural);
          }
        } else {
          let index = this.pluginsProject.find((p) => this.$route.path.includes(p.path));
          if (index !== undefined) {
            this.activeindex = index.name;
          }
          //await this.$store.dispatch(FECTH_NAME_SIDEBAR, index[0].display_name_plural);
        }
      }
    },
    async setPluginsProject() {
      await this.$store.dispatch(FECTH_PLUGINS_PROJECT);
    },
    async setAccessUser() {
      await this.$store.dispatch(FECTH_USER_ACCESS, this.currentUser.id);
    },
    async findActiveLink() {
      if (localStorage.getItem("user")) {
        let obj = localStorage.getItem("token");
        await this.$store
          .dispatch(FECTH_SIDEBAR, { token: obj, table: this.$route.params.db })
          .then((response) => {
            response.map((r) => {
              this.userAccessTables.map((t) => {
                if (r.id === t) this.links.push(r);
              });
            });
          })
          .catch((error) => console.log(error));
      }
    },
    cambio(href, name) {
      this.$router.push(href);
    },
    toggle() {
      this.isCollapse = !this.isCollapse;
      window.localStorage.setItem("isCollapse", this.isCollapse);
    },
    cssVarsCard() {
      return {
        "--bg-active": "#c6c6c6",
        "--bg-active-text": "#f8f8f8",
        "--el-card-padding": "5px",
      };
    },
    desconectar() {
      this.$store.dispatch(LOGOUT).then(() => {
        this.$router.push({ name: "Login" });
      });
    },
    homeDesconectar() {
      this.$router.replace("/home");
    },
    AdminConfig() {
      this.$router.replace("/admin");
    },
  },
  computed: {
    menuPluginsProject() {
      return this.pluginsProject;
    },
    ...mapGetters([
      "isAdmin",
      "currentUser",
      "getPluginsProject",
      "userAccessPlugins",
      "userAccessTables",
      "userGestorUsuarios",
    ]),
  },
  watch: {
    /*$route: function (newRoute, oldRoute) {
      this.$router.go(this.$router.currentRoute);
    },*/
  },
};
</script>
<style>
.avatar-card.small .el-avatar i {
  padding: 2px !important;
}
.avatar-card.small .el-avatar {
  font-size: 18px !important;
}
.avatar-card.small {
  padding: 5px !important;
}
.avatar-card .menu__custom {
  display: flex;
  align-items: center;
}
.avatar-card a {
  color: var(--bg-active-text);
  font-size: 20px;
}
.avatar-card .el-card__body {
  display: flex;
  width: 100%;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
}
.avatar-card.small .el-card__body {
  justify-content: center;
}
.avatar-card .el-card__body div {
  color: #000;
}
.avatar-card.small .text {
  display: none;
}
.avatar-card.small .aside-alert-link {
  display: none;
}
.avatar-card .el-avatar i {
  background: #000;
  border-color: #000;
  box-shadow: unset;
  border-radius: 30px;
  padding: 9px;
}
</style>
<style lang="scss" scoped>
.avatar-card .el-avatar {
  font-size: 44px;
  color: var(--bg-active-text);
  --el-avatar-bg-color: unset;
}

.avatar-card {
  width: 100%;
  padding: 16px;
  border-radius: 0px;
  margin: 5px 0px 0px;
  border: unset;
  background-color: var(--bg-active-text);
  display: flex;
  justify-content: flex-start;
  direction: ltr;
  box-shadow: unset !important;
  padding-bottom: 0px;
}
.el-aside {
  height: calc(100vh);
  overflow: auto;
  // height: calc(100vh);
}
.scroll_menu {
  height: calc(100vh - 50px);
  overflow: auto;
}
.el-menu-custom {
  border-right: none;
}
.logo {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: relative;
  > .simple-text {
    color: white;
    font-weight: 700;
    > .logo-img {
      max-height: 55px;
      max-width: 55px;
      display: inline-block;
      > img {
        max-width: 100%;
        padding-right: 10px;
      }
    }
  }
  .close {
    width: 64px;
  }
}

.el-menu-custom i {
  color: #fff !important;
}
.custom-sidebar_level .el-menu-item.is-active {
  background-color: #c6c6c6 !important;
  color: #000 !important;
}

.custom-sidebar_level i {
  color: #000 !important;
  font-size: 13px;
}
.custom-sidebar_level .el-menu-item {
  min-height: 35px;
  padding: 10px !important;
  text-wrap: balance;
  height: unset;
}
.custom-sidebar_level .el-menu-item {
  line-height: 1;
  display: flex;
  align-items: center;
}
.aside-alert-link_wrp i {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Sidebar.vue